import { render } from "./Profile.vue?vue&type=template&id=736b5188&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=736b5188&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-736b5188"

export default script